export class Monster {
    constructor(id, element, tier, baseHealth) {
        this.id = id;                  // Unique trace token (e.g., "monster_1717354921")
        this.element = element;        // Matches soulHandler: "fire", "water", etc.
        this.tier = tier;              // 1, 2, 3, 4
        
        // Stat scaling models based directly on the world tile tier
        this.maxHp = baseHealth * tier; 
        this.currentHp = this.maxHp;
        this.isDead = false;
        
        // Clean drop configuration parameters mapping straight into soulHandler parameters
        this.loot = {
            element: this.element,
            tier: this.tier,
            minSouls: 1 * tier,
            maxSouls: 3 * tier
        };
    }

    takeDamage(amount) {
        if (this.isDead) return { killed: false, damageDealt: 0 };

        this.currentHp = Math.max(0, this.currentHp - amount);
        
        if (this.currentHp <= 0) {
            this.isDead = true;
            return { killed: true, damageDealt: amount, loot: this.calculateDrops() };
        }

        return { killed: false, damageDealt: amount };
    }

    calculateDrops() {
        const amount = Math.floor(
            Math.random() * (this.loot.maxSouls - this.loot.minSouls + 1)
        ) + this.loot.minSouls;
        
        return {
            element: this.loot.element,
            tier: this.loot.tier,
            amount: amount
        };
    }

    toJSON() {
        return {
            id: this.id,
            element: this.element,
            tier: this.tier,
            maxHp: this.maxHp,
            currentHp: this.currentHp,
            isDead: this.isDead
        };
    }

    static fromJSON(data) {
        const monster = new Monster(data.id, data.element, data.tier, 1);
        monster.maxHp = data.maxHp;
        monster.currentHp = data.currentHp;
        monster.isDead = data.isDead;
        return monster;
    }
}